import { module } from "angular";
import favorites from "@gtmhub/favorites/favorites.module";
import featureToggles from "@gtmhub/featureToggle/module";
import { OkrViewComponent, OkrViewCtrl } from "@gtmhub/okrs/okr-views/components/okr-view/okr-view.component";
import { OkrViewsGridComponent } from "@gtmhub/okrs/okr-views/components/okr-views-grid/okr-views-grid.component";
import { OkrViewsListComponent, OkrViewsListCtrl } from "@gtmhub/okrs/okr-views/components/okr-views-list/okr-views-list.component";
import { loadModuleStyles } from "@gtmhub/shared/ng-extensions/util";
import { OkrViewsCopyLinkFormComponent } from "@webapp/okrs/okr-views/components/okr-views-copy-link-form/okr-views-copy-link-form/okr-views-copy-link-form.component";
import { OkrViewsGridAccessCellComponent } from "@webapp/okrs/okr-views/components/okr-views-grid/okr-views-grid-access-cell/okr-views-grid-access-cell.component";
import { OkrViewsGridCellComponent } from "@webapp/okrs/okr-views/components/okr-views-grid/okr-views-grid-cell/okr-views-grid-cell.component";
import moduleStyles from "./okr-views.module.less";

const mod = module("okr-views", [favorites, featureToggles]);

mod.component("okrView", OkrViewComponent);
mod.component("okrViewsList", OkrViewsListComponent);
mod.component("okrViewsGrid", OkrViewsGridComponent);
mod.downgradeComponent("okrViewsGridAccessCell", { component: OkrViewsGridAccessCellComponent, propagateDigest: false });
mod.downgradeComponent("okrViewsGridCell", { component: OkrViewsGridCellComponent, propagateDigest: false });
mod.downgradeComponent("okrViewsCopyLinkForm", { component: OkrViewsCopyLinkFormComponent, propagateDigest: false });

mod.controller("OkrViewCtrl", OkrViewCtrl);
mod.controller("OkrViewsListCtrl", OkrViewsListCtrl);

loadModuleStyles(mod, moduleStyles);

export default mod.name;
